"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcreteProduto = exports.Produto = void 0;
const Observer_Pattern_1 = require("../Observer_Pattern");
const js_big_decimal_1 = __importDefault(require("js-big-decimal"));
class Produto {
    constructor(codpro, despro, vlruni, pesliq, qtdped, pesbru) {
        this.desavi = 0;
        this.desext = 0;
        this.descar = 0;
        this.descam = 0;
        this.destop = 0;
        this.descontoRetiraNaFabrica = 0;
        this.tolmen = 0;
        this.mvaAjustado = 0;
        this.aliqInterestadual = 0;
        this.aliqInterna = 0;
        this.codICMSSubst = 0;
        this._ehValorManual = false;
        this.valorManual = 0;
        this.fixarFaixa = false;
        this.totpalete = 0;
        this.qtdlas = 0;
        this._vlrliq = 0;
        this._faixa = 'FX1';
        this.codpro = codpro;
        this.despro = despro;
        this._vlruni = vlruni;
        this._vlrori = vlruni;
        this.pesliq = pesliq;
        this.qtdped = qtdped;
        this.pesbru = pesbru;

        this.descontoCampanha = 0;
    }
    get valorST() {
        if (this.mvaAjustado != 0) {
            const MVAAPURADO = this.vlrProdutoPedido() * (this.mvaAjustado / 100);
            const BASEALIQ = MVAAPURADO + this.vlrProdutoPedido();
            const DEBTST = BASEALIQ * (this.aliqInterna / 100);
            const ICMSENTRADA = this.vlrProdutoPedido() * (this.aliqInterestadual / 100);
            return Number((DEBTST - ICMSENTRADA).toFixed(2));
        }
        else {
            return 0;
        }
    }
    set ehValorManual(ehManual) {
        this._ehValorManual = ehManual;
        this.desavi = 0;
        this.descam = 0;
        this.descar = 0;
        this.descontoRetiraNaFabrica = 0;
        this.desext = 0;
        this.destop = 0;
    }
    get ehValorManual() {
        return this._ehValorManual;
    }
    set faixa(v) {
        this._faixa = v;
        if (this.tolmen > 0) {
            if (!this.ehValorManual) {
                switch (this._faixa) {
                    case 'FX1':
                        this.vlruni = Number.parseFloat(new js_big_decimal_1.default(this.vlrori).multiply(new js_big_decimal_1.default('1.15')).round(2).getValue());
                        break;
                    case 'FX2':
                        this.vlruni = Number.parseFloat(new js_big_decimal_1.default(this.vlrori).multiply(new js_big_decimal_1.default('1.07')).round(2).getValue());
                        break;
                    case 'FX3':
                        this.vlruni = this.vlrori;
                        break;
                    default:
                        break;
                }
            }
            else {
                this.vlruni = this.vlrori;
            }
        }
    }
    get faixa() {
        return this._faixa;
    }
    get vlrliq() {
        const total = Number.parseFloat(new js_big_decimal_1.default(this.vlruni)
            .multiply(new js_big_decimal_1.default((100 - this.desavi) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.descam) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.descar) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.desext) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.destop) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.descontoRetiraNaFabrica) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.descontoCampanha) / 100))
            .round(2, js_big_decimal_1.default.RoundingModes.UP).getValue());
        if (this.ehValorManual) {
            return this.valorManual;
        }
        else {
            return total;
        }
    }
    get vlrori() {
        if (this.ehValorManual) {
            return this.valorManual;
        }
        else {
            return this._vlrori;
        }
    }
    get vlruni() {
        if (this.ehValorManual) {
            return this.valorManual;
        }
        else {
            return this._vlruni;
        }
    }
    set vlruni(v) {
        this._vlruni = v;
    }
    get totalDescontos() {
        const total = Number.parseFloat(new js_big_decimal_1.default((100 - this.desavi) / 100)
            .multiply(new js_big_decimal_1.default((100 - this.descam) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.descar) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.desext) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.destop) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.descontoRetiraNaFabrica) / 100))
            .multiply(new js_big_decimal_1.default((100 - this.descontoCampanha) / 100))
            .subtract(new js_big_decimal_1.default(1))
            .multiply(new js_big_decimal_1.default(100)).negate().getValue());
        return total;
    }
    get descontosInvalidos() {
        return this.totalDescontos > this.tolmen;
    }
    get pesoProdutoPedido() {
        return this.pesliq * this.qtdped;
    }
    get pesoBrutoProdutoPedido() {
        return this.pesbru * this.qtdped;
    }
    get qtdPalets() {
        return this.qtdped / this.totpalete;
    }
    get valorDescontoCampanha(){
        const totalProd = Number.parseFloat(new js_big_decimal_1.default(this.vlruni)
        .multiply(new js_big_decimal_1.default((100 - this.desavi) / 100))
        .multiply(new js_big_decimal_1.default((100 - this.descam) / 100))
        .multiply(new js_big_decimal_1.default((100 - this.descar) / 100))
        .multiply(new js_big_decimal_1.default((100 - this.desext) / 100))
        .multiply(new js_big_decimal_1.default((100 - this.destop) / 100))
        .multiply(new js_big_decimal_1.default((100 - this.descontoRetiraNaFabrica) / 100))
        .round(2, js_big_decimal_1.default.RoundingModes.UP).getValue());
        
        const totalDesc = Number.parseFloat(new js_big_decimal_1.default(totalProd)
        .multiply(new js_big_decimal_1.default((100 - this.descontoCampanha) / 100))
        .round(2, js_big_decimal_1.default.RoundingModes.UP).getValue());

        console.log({p: totalProd, d: totalDesc, c: totalProd - totalDesc })

        return (totalProd - totalDesc);

    }
    update(subject) {
        if (subject instanceof Observer_Pattern_1.ConcreteSubject) {
            if (!this.fixarFaixa) {
                this.faixa = subject.faixa;
            }
        }
    }
    vlrProdutoPedido() {
        return Number.parseFloat(new js_big_decimal_1.default(this.vlrliq)
            .multiply(new js_big_decimal_1.default(this.qtdped))
            .round(2, js_big_decimal_1.default.RoundingModes.UP)
            .getValue());
    }
    imprimir() {
        return `${this.codpro} - ${this.despro} | QTD: ${this.qtdped} | VLRLIQ: ${this.vlrliq} | FAIXA: ${this.faixa}`;
    }
}
exports.Produto = Produto;
class ConcreteProduto extends Produto {
    constructor(produto) {
        super(produto.codpro, produto.despro, produto.vlruni, produto.pesliq, produto.qtdped, produto.pesbru);
        this.totpalete = produto.totpalete;
        this.qtdlas = produto.qtdlas;
        this.tolmen = produto.tolmen;
        this.codICMSSubst = produto.codICMSSubst;
        this.mvaAjustado = produto.mvaAjustado;
        this.aliqInterestadual = produto.aliqInterestadual;
        this.aliqInterna = produto.aliqInterna;
        this.codICMSSubst = produto.codICMSSubst;
    }
}
exports.ConcreteProduto = ConcreteProduto;
